import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule, DatePipe, NgClass } from "@angular/common";
import { ImageCropperComponent } from "ngx-image-cropper";
import { AngularMaterialModule, LucideModule, SharedModule } from "app/shared";
import { ChangeOrgaoComponent } from './atricon-layout/header-atricon/change-orgao/change-orgao/change-orgao.component';
import { AuthLayoutComponent } from "./auth-layout/auth-layout.component";
import { AtriconLayoutComponent } from "./atricon-layout/atricon-layout.component";
import { MainLayoutComponent } from "./main-layout/main-layout.component";
import { HeaderAtriconComponent } from "./atricon-layout/header-atricon/header-atricon.component";
import { NavbarAtriconComponent } from "./atricon-layout/navbar-atricon/navbar-atricon.component";
import { SidebarAtriconComponent } from "./atricon-layout/sidebar-atricon/sidebar-atricon.component";
import { FooterAtriconComponent } from "./atricon-layout/footer-atricon/footer-atricon.component";
import { EmptyLayoutComponent } from "./empty-layout/empty-layout.component";
import { AbastecimentoLayoutComponent } from "./abastecimento-layout/abastecimento-layout.component";
import { HeaderAbastecimentoComponent } from "./abastecimento-layout/header-abastecimento/header-abastecimento.component";
import { MainHeaderComponent } from "./main-layout/main-header/main-header.component";
import { MainSidebarComponent } from "./main-layout/main-sidebar/main-sidebar.component";
import { MainFooterComponent } from "./main-layout/main-footer/main-footer.component";
import { TrocarClienteComponent } from "./main-layout/trocar-cliente/trocar-cliente.component";
import { MeuPerfilComponent } from "./main-layout/meu-perfil/meu-perfil.component";
import { ConfiguracoesComponent } from "./main-layout/configuracoes/configuracoes.component";
import { NotificacoesComponent } from "./main-layout/notificacoes/notificacoes.component";
import { NotificacoesHistoricoDialogComponent } from "./main-layout/notificacoes/notificacoes-historico-dialog/notificacoes-historico-dialog.component";
import { NotificacoesDetalhesComponent } from "./main-layout/notificacoes/notificacoes-detalhes/notificacoes-detalhes.component";
import { ThemeSettingsPanelComponent } from "./main-layout/theme-settings-panel/theme-settings-panel.component";
import { PerfilCropComponent } from "./main-layout/meu-perfil/perfil-crop/perfil-crop.component";

@NgModule({
  declarations: [
    ChangeOrgaoComponent,
    AuthLayoutComponent,
    AtriconLayoutComponent,
    MainLayoutComponent,
    HeaderAtriconComponent,
    NavbarAtriconComponent,
    SidebarAtriconComponent,
    FooterAtriconComponent,
    MainHeaderComponent,
    MainSidebarComponent,
    MainFooterComponent,
    EmptyLayoutComponent,
    AbastecimentoLayoutComponent,
    HeaderAbastecimentoComponent,
    TrocarClienteComponent,
    MeuPerfilComponent,
    ConfiguracoesComponent,
    NotificacoesComponent,
    NotificacoesHistoricoDialogComponent,
    NotificacoesDetalhesComponent,
    ThemeSettingsPanelComponent,
    PerfilCropComponent,
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    SharedModule,
    LucideModule,
    ImageCropperComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [],
  exports: [
    AtriconLayoutComponent,
    EmptyLayoutComponent,
    AbastecimentoLayoutComponent,
    MainLayoutComponent
  ]
})
export class LayoutModule { }
